import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const remainderReport = {
  path: '/remainderReport',
  component: Layout,
  name: 'remainderReportParent',
  redirect: '/remainderReport',
  children: [{
    path: '/remainderReport',
    component: () => import('@/views/remainderReport/index'),
    name: 'remainderReport',
    meta: {
      title: i18n.t(`message.remainder`)
    }
  }, ]
}

export default remainderReport